import React, { StrictMode, useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// Load Bootstrap once, in the entry chunk. Dozens of lazy route chunks import it
// individually, so without this its position in the cascade (relative to the module SCSS /
// QuoteStyle.css) depended on which route chunk the user happened to load first.
// The order is deliberate: bootstrap must stay AFTER index.css to preserve the old cascade.
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { trackPageView } from './Utils/tracking';

const ThemeContext = React.createContext(null);
const ThemeProvider = ({ children }) => (
    <ThemeContext.Provider value={{}}>
        {children}
    </ThemeContext.Provider>
);

// Fires trackPageView on every React Router navigation after the initial load.
// The initial load is already covered by initTracking() (GTM pageLoad, fbq PageView, UET pageLoad).
function TrackingRouteListener() {
    const location = useLocation();
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        trackPageView(location.pathname, document.title);
    }, [location.pathname]);

    return null;
};

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <ThemeProvider>
            <BrowserRouter>
                <TrackingRouteListener />
                <App />
            </BrowserRouter>
        </ThemeProvider>
    </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
